import {
    PriceDropQueryParameters,
    PageListBelowControlPriceGoodsInfoDTO,
    QueryBreakPriceOrdersByDistributorParam,
    PageListBreakPriceSimplenessOrderVo,
    ImportOrExportTaskResp,
    GetDrpBreakPriceOrderCountUsingGetParams,
    DrpBreakPriceOrderInfoVo,
} from '@servicesTypings/companyRequest'
import {
    QueryTurnAbnormalDetailUsingGetParams,
    TurnAbnormalDetail,
    TurnAbnormalParam,
    TurnAbnormalSupplierDetail,
} from '@servicesTypings/goodsRequest'
import { companyRequest, goodsRequest } from '@/utils/request'

// 查询破价商品信息
/**
 * 导出破价的商品信息
 */
export function queryDiscountedProductInformation(
    data: PriceDropQueryParameters,
): API.Res<PageListBelowControlPriceGoodsInfoDTO> {
    return companyRequest.post('/order/goods/queryDiscountedProductInformation', { data })
}

// 根据分销商查询破价的订单信息
/**
 * 根据分销商查询破价的订单信息
 */
export function queryBreakPriceOrdersByDistributor(
    data: QueryBreakPriceOrdersByDistributorParam,
): API.Res<PageListBreakPriceSimplenessOrderVo> {
    return companyRequest.post('/order/list/queryBreakPriceOrdersByDistributor', { data })
}

// 根据分销商导出破价的订单信息
/**
 * 根据分销商导出破价的订单信息
 */
export function breakPriceExportOrder(data: PriceDropQueryParameters): API.Res<ImportOrExportTaskResp> {
    return companyRequest.post('/order/list/exportBreakPriceOrdersByDistributor', { data })
}

// 导出破价的商品信息
/**
 * 导出破价的商品信息
 */
export function breakPriceExportGoods(data: PriceDropQueryParameters): API.Res<ImportOrExportTaskResp> {
    return companyRequest.post('/order/goods/exportDiscountedProductInformation', { data })
}

// 查询破价分销商及破价订单数量
/**
 * 破价总单数及各分销商破价单数接口
 */
export function getDrpBreakPriceOrderCount(
    params: GetDrpBreakPriceOrderCountUsingGetParams,
): API.Res<DrpBreakPriceOrderInfoVo> {
    return companyRequest.get('/order/list/getDrpBreakPriceOrderCount', { params })
}

// 查询商品转异常的商品编码
/**
 * 查询转异常详情
 */
export function queryTurnAbnormalDetail(params: QueryTurnAbnormalDetailUsingGetParams): API.Res<TurnAbnormalDetail> {
    return goodsRequest.get('/breakPrice/queryTurnAbnormalDetail', { params })
}

/**
 * 更新转异常
 */
export function turnAbnormalV2UsingPOST(data: TurnAbnormalParam): API.Res<null> {
    return goodsRequest.post('/breakPrice/turnAbnormalV2', { data })
}

/**
 * 管理控价查询商品列表
 */
export function queryGoodsListV2UsingGET(data: QueryGoodsListV2UsingGetParams): API.Res<BreakPriceResultVo[]> {
    return goodsRequest.post('/breakPrice/queryGoodsListV3', { data })
}
/**
 * 查询转异常信息
 */
export function queryTurnAbnormalSupplierDetailUsingGET(): API.Res<TurnAbnormalSupplierDetail> {
    return goodsRequest.get('/breakPrice/queryTurnAbnormalSupplierDetail')
}
